export const isObservabilityEnabled = (kind) => {
  const enabled = kind === 'performance'
    ? process.env.REACT_APP_OBSERVABILITY_PERFORMANCE === 'true'
    : kind === 'outcomes' && process.env.REACT_APP_OBSERVABILITY_OUTCOMES === 'true';
  if (!enabled) return false;
  try {
    return typeof window !== 'undefined' &&
      window.localStorage.getItem(`msales.observability.${kind}`) !== 'off';
  } catch (_) {
    return false;
  }
};
